var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-slide-group', {
    ref: "list",
    staticClass: "pa-4",
    attrs: {
      "show-arrows": ""
    }
  }, [_vm._l(_vm.products, function (product) {
    return [_c('v-slide-item', {
      key: product._id
    }, [_c('v-card', _vm._b({
      attrs: {
        "elevation": "0",
        "rounded": "0"
      }
    }, 'v-card', {
      width: _vm.width
    }, false), [_vm._t("list-item", null, {
      "product": product
    })], 2)], 1)];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }